import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime } from 'rxjs/operators';
import { DialogBase } from 't4core';
import { RequestDetails } from 't4core';


@Component({
    selector: 'owa-findIssueDialog',
    templateUrl: 'findIssueDialog.html',
})
export class T4_FindIssueDialog extends DialogBase {
    public requests: RequestDetails[] = [];
    public selectedRequest: RequestDetails = null;

    public txtKeywords: FormControl = new FormControl();

    @ViewChild('requestList', { static: false }) requestList: ElementRef;
    constructor(
        public dialogRef: MatDialogRef <T4_FindIssueDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("FindIssueDialog");

        this.txtKeywords.valueChanges.pipe(debounceTime(1000))
            .subscribe(() => {
                this.findRequests();
            });
  } 
  
    private findRequests() {
        var token = this.beginLoad('Turbo.OneWayAdmin.FindIssueDialog.msgSearching', 'Looking for service requests', null);
        this.Api.get<RequestDetails[]>('/Service/FindRequests', { keywords: this.txtKeywords.value }).then(x => {
          this.requests = x;
          if (this.requests.length > 0) {
            this.selectedRequest = this.requests[0];
          }
          else {
            this.selectedRequest = null;
          }
            this.endLoad(token);
        });
    }

  public showSelectedRequest() {
    this.dialogRef.close(this.selectedRequest);
  }

  public handleEnterKey(event: any) {
    if (event.key === 'Enter') {
      this.showSelectedRequest();
    }    
  }

  public handleTexFieldKeyPress(event: any) {
    if (event.key === 'Enter') {
      if (this.requests.length > 0) {
        this.requestList.nativeElement.focus();
      }
    }
  }
  
}
